import { AnimateSharedLayout, motion } from "framer-motion"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import "./tabnav.scss"

const spring = {
  type: "spring",
  stiffness: 50,
  damping: 30,
}

const TabNav = ({
  tabs,
  active,
  setActive,
  blockTabs = false,
}: $TSMigrationFixMe) => {
  const history = useHistory()
  const handleChangeTab = (tab: $TSMigrationFixMe) => {
    if (tab.id === 3) {
      history.push(ROUTES.BANCOS)
    }
    if (!blockTabs) return setActive(tab.id)

    if (tab.id <= active) {
      setActive(tab.id)
    }
  }
  return (
    <div className='tab-nav-head'>
      <AnimateSharedLayout>
        {tabs?.map(
          (tab: $TSMigrationFixMe) =>
            !tab?.hide && (
              <div
                key={tab.id}
                onClick={() => handleChangeTab(tab)}
                className={`tab-nav-item ${tab?.id === active ? "active" : ""}`}
              >
                {tab?.header}

                {tab?.quantity >= 1 && (
                  <span className='quantity-tab'>{tab.quantity}</span>
                )}

                {tab?.id === active && (
                  <motion.div
                    transition={spring}
                    animate={{ borderColor: "#004AD1" }}
                    initial={false}
                    className='active'
                  />
                )}
              </div>
            )
        )}
      </AnimateSharedLayout>
    </div>
  )
}

export default TabNav
